import { render, staticRenderFns } from "./NoticeOfPrivacyPractices.vue?vue&type=template&id=7db1d8f8"
import script from "./NoticeOfPrivacyPractices.vue?vue&type=script&lang=js"
export * from "./NoticeOfPrivacyPractices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports